const Joi = require('joi')
const fields = require('../fields')

const checkoutTransactionFiltersSchema = Joi.object({
    state: fields.transactionCategoryField.optional(),
    startDate: Joi.date().optional().label('Start Date'),
    endDate: Joi.date().optional().label('End Date'),
})

module.exports = checkoutTransactionFiltersSchema